import { useState } from "react";
import { Modal, Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function ImagePreviewModal({ open, onClose, src }) {
   const [imgError, setImgError] = useState(false);

   return (
      <Modal open={open} onClose={onClose}>
         <Box
            sx={{
               position: "absolute",
               top: "50%",
               left: "50%",
               transform: "translate(-50%, -50%)",
               bgcolor: "background.paper",
               boxShadow: 24,
               p: 2,
               width: "80vw",
               maxWidth: 900,
               height: "80vh",
               minHeight: 400,
               outline: "none",
               display: "flex",
               alignItems: "center",
               justifyContent: "center",
            }}
         >
            {/* Кнопка закриття */}
            <IconButton
               onClick={onClose}
               sx={{ position: "absolute", top: 8, right: 8 }}
            >
               <CloseIcon />
            </IconButton>

            {/* Контент */}
            {src && !imgError ? (
               <img
                  src={src}
                  alt=""
                  onError={() => setImgError(true)}
                  style={{
                     maxWidth: "100%",
                     maxHeight: "100%",
                     objectFit: "contain",
                  }}
               />
            ) : (
               <Typography color="text.secondary">
                  Зображення недоступне
               </Typography>
            )}
         </Box>
      </Modal>
   );
}
